import React from 'react';
import { Modal, ModalBody, ModalHeader, Col } from 'reactstrap';

function CodeModal(props) {
  const toggle = () => {
    console.log(13, 'Toggle');
  };

  return (
    <Modal isOpen={props.isOpen} className='code-modal' toggle={toggle} modalTransition={{ timeout: 500 }}>
      <ModalHeader className='my-2'>
        <i className='fa-solid fa-circle-xmark codemodal-exit-icon mt-1' onClick={() => props.close()}></i>
        <h4 className='mt-2'>Your Authentication Code</h4>
      </ModalHeader>
      <ModalBody className='p-0'>
        <Col className='justify-content-center'>
          <p className='d-flex justify-content-center'>
            Enter the authentication code below to access your disclosures. This is a one-time authentication.
          </p>
          <h3 className='d-flex justify-content-center'>{props.authenticationCode}</h3>
        </Col>
      </ModalBody>
    </Modal>
  );
}

export default CodeModal;
